<template>
  <div class="layout">
    <Menu
      ref="use"
      class="topL fixed"
      mode="horizontal"
      :theme="theme1"
      :active-name="activeName_top"
      @on-select="topFun"
    >
      <!-- 左侧标志 -->
      <div class="logo" @click="server">
        <!--点击logo，刷新服务器(上传代码后，需刷新服务器才可使用)-->
        <img
          src="../../public/images/logo.jpg"
          @click="$router.push({ path: '/layout' })"
        />
      </div>
      <!-- 选项 -->

      <MenuItem
        v-for="(itemTop, num) in menu"
        :id="num"
        :name="itemTop.url"
        :to="itemTop.url"
      >
        <Icon :type="itemTop.menuImage" />
        {{ itemTop.menuName }}
      </MenuItem>
      <!-- <MenuItem name="2">
            <Icon type="ios-people" />
            用户
        </MenuItem>-->
    </Menu>

    <!-- 右侧选择 -->
    <div class="topR" @mouseenter="mEnter" @mouseleave="mLeave">
      <!-- 通过悬停触发 -->
      <div class="my_hover" v-if="my_hover">
        <div class="mh mh_01">
          <img
            class="ta_01"
            v-if="user_image"
            :src="is_change_image"
            :onerror="errorImg"
            alt=""
          />
          <img
            class="ta_02"
            v-if="!user_image && theme1 == 'light'"
            src="../../public/images/head_01.png"
            alt=""
          />
          <img
            class="ta_03"
            v-if="!user_image && theme1 != 'light'"
            src="../../public/images/head_02.png"
            alt=""
          />
        </div>
        <div class="mh mh_02" v-if="user.lastLoginTime">
          上次登陆时间: {{ user.lastLoginTime }}
        </div>
        <div class="mh mh_03">上次登陆IP: {{ user.lastLoginIp }}</div>
        <div class="mh mh_04">
          <Button
            @click="mh1Fun"
            style="margin-right:20px"
            size="small"
            type="info"
            icon="md-contact"
            >个人资料</Button
          >
          <Button
            @click="mh2Fun"
            style="margin-right:20px"
            size="small"
            type="success"
            icon="md-home"
            >返回首页</Button
          >
          <Button @click="closeFun" size="small" type="error" icon="md-power"
            >退出账号</Button
          >
        </div>
      </div>

      <!-- 关闭图片 -->
      <div class="topR_all  topR_03">
        <img
          class="close"
          v-if="theme1 == 'light'"
          src="../../public/images/close_01.png"
          alt=""
        />
        <img
          class="close"
          v-if="theme1 != 'light'"
          src="../../public/images/close_02.png"
          alt=""
        />
      </div>

      <!-- 姓名         -->
      <div class="topR_all  topR_02">
        <span :class="[theme1 == 'light' ? 'fontColorB' : 'fontColorW']">
          {{ user_name }}</span
        >
      </div>

      <!-- 头像 -->
      <div class="topR_all  topR_01">
        <Avatar
          v-if="user_image"
          size="35"
          :src="is_change_image"
          :onerror="errorImg"
          alt=""
        />
        <Avatar v-if="!user_image" size="35" icon="ios-person" alt="" />
      </div>
    </div>

    <!-- 左侧路由  -->

    <!-- 正常路由 -->
    <Menu
      class="lftT  fixed "
      v-for="(items, num) in menu"
      v-if="
        items.downMenus[0] &&
          [items.downMenus[0].url.indexOf(activeName_top)] != -1 &&
          items.url != '/layout/circle'
      "
      width="230px"
      mode="vertical"
      :theme="theme1"
      :active-name="activeName_lft.replace(/[0-9]/, '').replace(/_child/, '')"
    >
      <MenuItem
        v-for="(my_item, num2) in items.downMenus"
        :id="num2"
        :name="my_item.url"
        :to="my_item.url"
        v-if="my_item.isButton !== 1"
      >
        <Icon :type="my_item.menuImage" />
        {{ my_item.menuName }}
      </MenuItem>
    </Menu>

    <!-- 路由为  /layout/circle 时会多添加一层 -->
    <Menu
      class="lftT  fixed "
      v-for="(items, num) in menu"
      v-if="
        items.downMenus[0] &&
          [items.downMenus[0].url.indexOf(activeName_top)] != -1 &&
          items.url == '/layout/circle'
      "
      width="230px"
      mode="vertical"
      :theme="theme1"
      :active-name="activeName_lft.replace(/[0-9]/, '')"
      :open-names="[name_open]"
      accordion
    >
      <!-- 动态管理 -->
      <Submenu name="1">
        <template slot="title">
          <Icon type="ios-create" />
          动态管理
        </template>
        <MenuItem
          v-for="(my_item, num2) in items.downMenus"
          v-if="
            (my_item.url.indexOf('classify') != -1 ||
              my_item.url.indexOf('content') != -1 ||
              my_item.url.indexOf('recommend') != -1 ||
              my_item.url.indexOf('gambit') != -1 ||
              my_item.url.indexOf('postReport') != -1 ||
              my_item.url.indexOf('delAll') != -1 ||
              my_item.url.indexOf('task') != -1) &&
              my_item.isButton !== 1
          "
          :id="num2"
          :name="my_item.url"
          :to="my_item.url"
        >
          <Icon :type="my_item.menuImage" />
          {{ my_item.menuName }}
        </MenuItem>
      </Submenu>
      <!-- 百家姓管理 -->
      <Submenu name="2">
        <template slot="title">
          <Icon type="md-contacts" />
          百家姓管理
        </template>
        <MenuItem
          v-for="(my_item, num2) in items.downMenus"
          v-if="my_item.url.indexOf('surname') != -1 && my_item.isButton !== 1"
          :id="num2"
          :name="my_item.url"
          :to="my_item.url"
        >
          <Icon :type="my_item.menuImage" />
          {{ my_item.menuName }}
        </MenuItem>
      </Submenu>
      <!-- 广告管理 -->
      <Submenu name="3">
        <template slot="title">
          <Icon type="ios-desktop" />
          广告管理
        </template>
        <MenuItem
          v-for="(my_item, num2) in items.downMenus"
          v-if="my_item.url.indexOf('banner') != -1 && my_item.isButton !== 1"
          :id="num2"
          :name="my_item.url"
          :to="my_item.url"
        >
          <Icon :type="my_item.menuImage" />
          {{ my_item.menuName }}
        </MenuItem>
      </Submenu>
      <!-- 纪念堂管理 -->
      <Submenu name="4">
        <template slot="title">
          <Icon type="md-home" />
          纪念堂管理
        </template>
        <MenuItem
          v-for="(my_item, num2) in items.downMenus"
          v-if="
            (my_item.url.indexOf('memorial') != -1 ||
              my_item.url.indexOf('music') != -1 ||
              my_item.url.indexOf('background') != -1 ||
              my_item.url.indexOf('gift') != -1) &&
              my_item.isButton !== 1
          "
          :id="num2"
          :name="my_item.url"
          :to="my_item.url"
        >
          <Icon :type="my_item.menuImage" />
          {{ my_item.menuName }}
        </MenuItem>
      </Submenu>
      <!-- 资讯 -->
      <Submenu name="5">
        <template slot="title">
          <Icon type="md-headset" />
          资讯管理
        </template>
        <MenuItem
          v-for="(my_item, num2) in items.downMenus"
          v-if="
            my_item.url.indexOf('baiduManage') != -1 && my_item.isButton !== 1
          "
          :id="num2"
          :name="my_item.url"
          :to="my_item.url"
        >
          <Icon :type="my_item.menuImage" />
          {{ my_item.menuName }}
        </MenuItem>
      </Submenu>
      <Submenu name="6">
        <template slot="title">
          <Icon type="md-book" />
          阅读管理
        </template>
        <MenuItem
          v-for="(my_item, num2) in items.downMenus"
          v-if="
            my_item.url.indexOf('audio') != -1 ||
            my_item.url.indexOf('album') != -1 ||
              (my_item.url.indexOf('category') != -1 && my_item.isButton !== 1)
          "
          :id="num2"
          :name="my_item.url"
          :to="my_item.url"
        >
          <Icon :type="my_item.menuImage" />
          {{ my_item.menuName }}
        </MenuItem>
      </Submenu>
    </Menu>

    <div class="content">
      <div class="con_top h_48"></div>
      <!-- 下一级路由 -->
      <div class="con_padding">
        <router-view></router-view>
      </div>
    </div>

    <div class="page_bottom"></div>

    <!-- 编辑弹窗 -->
    <Modal
      v-model="modal1"
      title="个人资料编辑"
      @on-ok="change"
      @on-cancel="cancel1"
      class-name="vertical-center-modal"
    >
      <div slot="footer">
        <Button type="text" size="large" @click="cancel1">取消</Button>
        <Button type="primary" size="large" @click="change">提交</Button>
      </div>
      <ul class="layout_ul">
        <!-- 当前头像-->
        <li style="height:150px">
          <!-- 切换头像 -->
          <div class="old_head">
            <cropper
              @childFun="childFun2"
              head_type="user"
              :head_bool="modal1"
              :data="cropper_data"
            ></cropper>
          </div>
        </li>

        <!-- 用户名 -->
        <li>
          <div class="list_title"><span class="cRed">*</span> 用户名 :</div>
          <div class="list_con">
            <Input
              disabled
              type="text"
              class="ipt"
              placeholder="请输入用户名"
              v-model="user_name"
            />
          </div>
        </li>
        <!-- 手机号 -->
        <li>
          <div class="list_title"><span class="cRed">*</span> 用户账号 :</div>
          <div class="list_con">
            <Input
              disabled
              type="text"
              class="ipt"
              placeholder="请输入用户账号"
              v-model="mobile"
            />
          </div>
        </li>

        <!-- 新密码-->
        <li>
          <div class="list_title"><span class="cRed">*</span> 新密码 :</div>
          <div class="list_con">
            <Input
              type="password"
              class="ipt"
              placeholder="请输入新密码"
              v-model="new_password"
            />
          </div>
        </li>
        <!-- 确认密码-->
        <li>
          <div class="list_title"><span class="cRed">*</span> 确认密码 :</div>
          <div class="list_con">
            <Input
              type="password"
              class="ipt"
              placeholder="请输入确认密码"
              v-model="new_password_02"
            />
          </div>
        </li>
      </ul>
    </Modal>

    <!-- 返回顶部 -->
    <BackTop :height="100" :bottom="20" :duration="1000">
      <Icon type="md-arrow-round-up" size="20" color="white" class="goTop" />
    </BackTop>
  </div>
</template>

<script>
// vuex
import { mapState, mapMutations, mapGetters } from "vuex";

import { format } from "path";
import CryptoJS from "crypto-js";
import cropper from "@/views/child_vue/vue_cropper.vue";

export default {
  name: "layout",
  data() {
    return {
      name_open: "1",
      // 子路由刷新一级路由媒介
      layout: false,
      // vuex
      token: "",
      image: null,
      tan_img: null, //弹窗头像
      user_name: "admin",
      theme1: "dark",

      menu: null,
      user: Object,
      //   图片错误
      errorImg: 'this.src="' + require("../../public/images/head_01.png") + '"',

      activeName_top: 0,
      activeName_lft: 0,

      user_image: false,
      currentRouter: "/",

      //  导航栏
      titleT: 0,
      titleL: 0,

      //   弹窗
      my_hover: false,
      name: "",
      mobile: "",
      password: "",

      old_password: "",
      new_password: "",
      new_password_02: "",

      my_data: {
        guid: null,
        type: 0
      },

      modal1: false, //弹窗
      image_name: null,
      image_path: null,

      cropper_data: {
        vCropper: "0", //插件分组(同一页面不能使用两个vue-cropper,通过v-if进行判断,因多级路由使父路由和子路由也存在冲突所以用vuex鉴别)
        btn_name: "上传图片",
        outputType: "jpeg", //生成图片格式
        type: "0", //图片分组
        enlarge: "1", //倍数
        autoCropWidth: "200",
        autoCropHeight: "200"
      },

      child_val: null //child 反馈
    };
  },
  components: { cropper },
  props: ["uploadType"],

  watch: {
    is_change_layout: function(val, old) {
      this.onLoad();
    },
    theme1(val, old) {
      var that = this;
      window.localStorage.setItem("select_color", val);
    },
    $route: function(to, from) {
      var that = this;
      that.currentRouter = to.path;
      that.routerFun(that.currentRouter);

      // 发现管理设置
    },
    name_open(val, old) {},
    activeName_lft(val) {
      let that = this;
      that.fxFun(this.activeName_lft.replace(/[0-9]/, ""));
    },
    activeName_top(val) {
      let that = this;
      if (that.menu) {
        let menu_len_i = that.menu.length;

        // 当默认目录不在，则选第一个
        for (let i = 0; i < menu_len_i; i++) {
          // console.log(that.menu[i].url,val);
          if (val == that.menu[i].url && that.menu[i].downMenus[0].url) {
            that.activeName_lft = that.menu[i].downMenus[0].url;
            that.$router.push({ path: that.activeName_lft });
          }
        }
      }
    }
  },

  beforeMount() {
    this.currentRouter = this.$route.path;
  },

  computed: {
    is_change_image() {
      return this.$store.getters.is_change_image;
    },

    is_change_layout() {
      var that = this;

      return this.$store.getters.is_change_layout;
    },
    is_change_vCropper() {
      var that = this;

      return this.$store.getters.is_change_vCropper;
    }
  },

  methods: {
    onLoad() {
      var that = this;

      // vuex
      that.image = that.$store.state.image;
      that.tan_img = that.$store.state.image;
      that.token = that.$store.state.token;
      that.vCropper = that.$store.state.vCropper;

      that.theme1 = "dark";
      if (!window.localStorage.getItem("select_color")) {
        that.select_color = window.localStorage.setItem("select_color", "dark");
        that.theme1 = "dark";
      } else {
        var select_color = window.localStorage.getItem("select_color");

        that.theme1 = select_color;
      }

      that.$myAjax.get("admin/service/admin/menu_user").then(res => {
        that.menu = res.data.data.menu;

        // 缓存菜单
        that.$store.commit("change_menu", that.menu);

        that.user = res.data.data.user;

        if (!that.image || that.image == undefined) {
          that.user_image = false;
        } else {
          that.user_image = true;
        }
        // that.user_name = res.data.data.user.surname+res.data.data.user.name;
        that.user_name = res.data.data.user.nick;
        that.$nextTick(() => {
          that.$refs.use.updateOpened();
          that.$refs.use.updateActiveName();
        });

        that.activeName_lft = that.$route.path;
        // console.log(that.activeName_lft);
      });
    },
    // 发现管理
    fxFun(opt) {
      let that = this;

      if (opt) {
        if (
          opt.indexOf("classify") != -1 ||
          opt.indexOf("content") != -1 ||
          opt.indexOf("recommend") != -1 ||
          opt.indexOf("gambit") != -1 ||
          opt.indexOf("postReport") != -1 ||
          opt.indexOf("delAll") != -1 ||
          opt.indexOf("task") != -1
        ) {
          that.name_open = "1";
        } else if (opt.indexOf("surname") != -1) {
          that.name_open = "2";
        } else if (opt.indexOf("banner") != -1) {
          that.name_open = "3";
        } else if (
          opt.indexOf("memorial") != -1 ||
          opt.indexOf("music") != -1 ||
          opt.indexOf("background") != -1 ||
          opt.indexOf("gift") != -1
        ) {
          that.name_open = "4";
        } else if (opt.indexOf("baiduManage") != -1) {  
          that.name_open = "5";
        } else if (opt.indexOf("audio") != -1 || opt.indexOf("album") != -1 || opt.indexOf("category") != -1) {
          that.name_open = "6";
        }
      }
    },
    lft_numFun(num1, num2) {
      var num_all = parseInt(num1.toString() + num2.toString());
      return num_all;
    },

    // 顶部导航选择
    topFun(name) {
      var that = this;
    },
    closeFun() {
      var that = this;
      that.$store.commit("change_token", "");
      //    window.close(); //vue中失效
      that.$router.push({ path: "/" });
    },

    //  由路由决定导航
    routerFun(router) {
      var that = this;
      var my_indexOf = that.currentRouter.lastIndexOf("/");

      that.activeName_top = that.currentRouter.slice(0, my_indexOf);
      //    that.activeName_lft = that.currentRouter;
      that.activeName_lft = that.$route.path;
      // console.log(that.currentRouter);
    },

    server() {
      var that = this;

      that.$myAjax
        .get("https://api.jiapuji.vip/gateway/attached/service/h5/update")
        .then(res => {});
    },
    //    个人资料
    mh1Fun() {
      let that = this;
      that.modal1 = true;
      // 重置参数
      that.old_password = "";
      that.new_password = "";
      that.new_password_02 = "";
      that.tan_img = that.is_change_image;
      that.image_name = null;
    },
    //    返回首页
    mh2Fun() {
      let that = this;
      that.$router.push({ path: "/layout" });
    },

    //    弹窗
    load() {
      var that = this;
      //    vuex
      that.image = that.$store.state.image;
      that.token = that.$store.state.token;
      that.guid = that.$store.state.guid;
      that.name = that.$store.state.name;
      that.mobile = that.$store.state.mobile;
      that.password = that.$store.state.password;
    },

    // 提交按钮
    change() {
      var that = this;
      that.password = that.password.replace(/\s*/g, "");
      that.old_password = that.old_password.replace(/\s*/g, "");
      that.new_password = that.new_password.replace(/\s*/g, "");
      that.new_password_02 = that.new_password_02.replace(/\s*/g, "");
      if (that.new_password && that.new_password != that.new_password_02) {
        that.$alert.info("两次输入密码不一致!");
      } else if (
        that.new_password &&
        (that.new_password.length < 6 || that.new_password_02.length < 6)
      ) {
        that.$alert.info("密码不小于6位数");
      } else {
        if (false) {
          that.$alert.info("密码不能小于6位111");
        } else {
          // 加密密码
          var encrypt_password;
          if (!that.new_password) {
            encrypt_password = null;
          } else {
            encrypt_password = CryptoJS.HmacSHA1(that.new_password, "OT2NDh41")
              .toString()
              .toUpperCase();
          }

          let data = {
            guid: that.guid,
            password: encrypt_password,
            image: null
          };

          if (!that.child_val) {
            that.$myAjax.put("admin/service/admin/update ", data).then(res => {
              // that.$alert.info(res);

              that.$store.commit("change_password", that.new_password);
              that.password = that.new_password;
              if (res.data.code == 1) {
                that.cancel1();
              }
              // console.log('改密码结果',res)
            });
          } else {
            that.$upload(that.child_val).then(res => {
              data.image = res.data.data.name;
              that.$myAjax
                .put("admin/service/admin/update ", data)
                .then(res_c => {
                  that.$store.commit("change_image", res.data.data.path); //修改vuex的image

                  that.$store.commit("change_password", that.new_password);
                  that.password = that.new_password;
                  if (res_c.data.code == 1) {
                    that.cancel1();
                  }
                });
            });
          }
        }
      }
    },
    cancel1() {
      let that = this;
      that.modal1 = false;
    },

    mEnter() {
      this.my_hover = true;
    },
    mLeave() {
      this.my_hover = false;
    },

    childFun2(data) {
      let that = this;
      that.child_val = data.pic_url;
      // that.image_name =  data.pic_url.name;
      // that.image_path =  data.pic_url.path;
    }
  },
  mounted: function() {
    var that = this;
    that.fxFun();

    that.layout = that.is_change_layout;

    that.routerFun(that.currentRouter);
    // 加载内容，vue无onLoad()
    that.onLoad();
    // console.log(that.currentRouter);
    that.load();
    var loadImg = function(imgSrc) {
      return "this.οnlοad=null;this.src=" + '"' + imgSrc + '";';
    };
    var errorImg = function() {
      return (
        "this.οnlοad=null;this.src=" + '"../../static/img/avatar13@3x.png";'
      );
    };

    //    console.log('token',that.$store.state.token);
  }
};
</script>
<style>
@import "/css/index.css";
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /** IE10+  ie浏览器的样式**/
  .ivu-modal {
    left: -50%;
    transform: translateX(50%);
  }
}

.aplayer-volume-wrap {
  /**音乐播放组件的喇叭按钮 **/
  margin-top: -4.5px;
}
.mSwitch {
  margin-top: 7px;
}
.goTop {
  padding: 10px !important;
  background: #2db7f5;
  border-radius: 50%;
}

/* 在layout才生效 */
.index_list .top .ivu-tabs-tab {
  height: 70px;
  line-height: 62px; /****  减去padding 8 */
}
.colorP {
  color: #2d8cf0;
}

.tree {
  float: left;
}
.tree li {
  width: 200px;
}
.tree * {
  text-align: left !important;
}

.ivu-table-wrapper {
  overflow: visible !important;
}

.page_bottom {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  z-index: 1;
}

/* hover */
.my_hover {
  position: absolute;
  top: 60px;
  right: 0;
  background: #515a6e;
  width: 350px;
  height: 220px;
  z-index: 99999;
  border-top: 1px solid #f7f9ff;
  padding: 10px;
}
.my_hover .mh {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}
.my_hover .mh_01 {
  height: 90px;
}
.my_hover .mh_01 img {
  height: 90%;
  border-radius: 50%;
}
.my_hover .mh_02 {
  height: 30px;
}
.my_hover .mh_03 {
  height: 30px;
}
.my_hover .mh_04 {
  height: 50px;
}
/* 弹窗 */
.layout_ul {
  width: 100%;
  height: auto;
}
.layout_ul li {
  width: 100%;
  height: auto;
  overflow: hidden;
  padding: 5px 0;
}
.layout_ul .list_title {
  float: left;
  width: 26%;
  text-align: right;
  padding-right: 10px;
  line-height: 32px;
  font-size: 14px;
}
.layout_ul .list_con {
  float: left;
  width: 60%;
}

.tree {
  float: left;
}
.tree * {
  text-align: left;
}

/* 头像 */
.layout_ul .old_head {
  position: absolute;
  top: 72px;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: auto;
}
.layout_ul .old_head img {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  overflow: hidden;
  width: 100px;
  height: 100px;
  background: white;
  z-index: 99;
}
.sctx {
  width: 100%;
  height: 16px;
  margin-top: 110px;
  text-align: center;
  color: #1abc9c;
  font-size: 12px;
}

.table_top {
  height: 516px;
}
.imgS {
  width: 100px;
  height: 100px;
}
.imgS img {
  height: 100%;
}

button,
.pointer,
.sta_btn {
  cursor: pointer;
}
* {
  font-family: "微软雅黑";
}
/* 底部确认按钮 */
.btn {
  font-size: 15px !important;
  font-weight: 400 !important;
  color: white !important;
  background: #1abc9c !important;
  cursor: pointer;
}

.fontColorW {
  color: white;
}
.fontColorB {
  color: black;
}
ul:not(.uditor1) {
  list-style-type: none;
}

body,
html {
  width: 100%;
  height: auto;
  /* overflow: hidden; */
}
#app {
  width: 100%;
  height: 100%;
}

.layout {
  height: auto;
}
.ivu-menu-vertical {
  height: 100%;
}
.ivu-menu-vertical li {
  text-align: left !important;
}
.logo {
  float: left;
  height: 100%;
  width: 230px;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #404757;
}
.logo img {
  height: 100%;
}
/* 顶部 */
/* 顶部左侧 */
.topL {
  width: 100%;
}
/* 顶部右侧 */
.topR {
  position: fixed !important;
  top: 0;
  right: 0;
  min-width: 100px;
  height: 59px;
  /* overflow: hidden; */
  background: #515a6e;
  z-index: 900;
  font-size: 14px;
}
.topR .topR_all {
  position: relative;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;
}
.topR .topR_01 {
  width: 60px;
}
.topR .topR_02 {
  width: auto;
  justify-content: start;
  text-align: left;
  font-size: 12px;
}
.topR .topR_03 {
  width: 60px;
}
.topR .topR_02 span {
  display: inline-block;
  width: 100%;
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
  word-break: normal !important;
}
.topR .topR_01 img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  overflow: hidden;
}
.topR .topR_03 img {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  overflow: hidden;
}
.close {
  transform: scale(0.7);
}
/* 左侧 导航 */
.lftT {
  text-align: left;
  top: 60px !important;
}
/* 色彩选择 */
.menu_color {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 999;
  width: 230px;
}

.untop {
  width: 100%;
  height: 100%;
}
/* content内容 */

.content {
  position: relative;
  width: calc(100% - 230px);
  height: calc(100% - 60px);
  margin-top: 60px;
  margin-left: 230px;
  z-index: 9;
  /* overflow: auto; */
}
body::-webkit-scrollbar {
  display: none;
}

.con_top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  /* background: #f3f3f3; */
}

.con_padding {
  position: relative;
  /* padding: 0 45px; */
}
/* 下一级路由样式 */
.content .con_content {
  position: relative;
  width: 100%;
  height: auto;
}
.container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0 auto;
  /* width: 1100px; */
  /* width: 100%; */
  min-height: 10px;
}
/* 顶部 */
.container .container_top {
  width: 100%;
  text-align: left;
  display: block;
  font-size: 16px;
  color: #999;
  /* background: #f3f3f3; */
}
.container .container_top:before {
  content: "▍";
  color: #1abc9c;
  font-weight: 900;
  margin-right: 10px;
}

/* table组件 */
.my_table {
  margin-top: 20px;
  width: 100%;
  padding: 0;
}
.my_title_table {
  background: white;
  /* padding: 0 35px; */
  /* padding-bottom: 50px !important; */
}
.my_body {
  padding: 30px 0 30px;
  background: white;
  border: 1px solid #e4e4e4;
}

/* 竖排input列表 */
.list {
  position: relative;
  width: 100%;
  min-height: 20px;
}

.li_all {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
.li_all li {
  width: 240px;
  height: 50px;
}
.li_lft {
  left: calc(50% - 255px);
}
.li_lft p {
  height: 36px;
  font-size: 14px;
  padding: 6px 7px;
  text-align: right;
}
.li_lft li span {
  color: red;
}
.user_btn {
  margin-top: 15px;
  width: 100px;
}
/* 全局表格 */
.heng_table .ivu-table .ivu-table-header {
  display: none !important;
}
.heng_table .ivu-table td:nth-child(odd) {
  font-weight: 900;
  background: #f8f8f9 !important;
}
.heng_table .ivu-table span {
  font-size: 15px;
}
/* 顶部名称 */
.con_content .my_title {
  width: 100%;
  height: 60px;
  line-height: 60px;
  margin-top: 20px;
  padding-left: 10px;
  background: white;
  padding: 0 15px;
  border: 1px solid #e4e4e4;
  border-bottom: none;
  font-size: 14px;
}
/* 顶部无名称 */
.no_title {
  margin-top: 20px;
}

/* 去除拖拽图片区域的border */
.ivu-upload-drag {
  border: none !important;
}
/* 公用顶部搜索 */
.my_search {
  width: 100%;
  height: 60px;
  line-height: 60px;
}
.my_search .search_row {
  background: white;
  border: 1px solid #e4e4e4;
}
.my_search .ivu-col {
  line-height: 57px;
}
.my_search .search_name {
  display: inline-block;
  float: left;
  margin-left: 20px;
  margin-right: 20px;
  font-size: 15px;
}

/* 公用综合统计右侧按钮 */
.ct_rgt {
  width: auto;
  height: 100%;
  float: right;
}
.ct_rgt .sta_btn {
  float: right;
  width: 88px;
  height: 30px;
  line-height: 28px;
  margin-top: 14px;
  text-align: center;
  /* background: #1abc9c; */
  border: 1px solid #ccc;
}

/* 名字带2文件的返回按钮 */
.back_btn {
  float: left;
  margin-right: 20px;
  width: 88px;
  height: 30px;
  line-height: 28px;
  margin-top: 9px;
  text-align: center;
  /* border: 1px solid #ccc; */
  border-radius: 5px;
  background: #5cadff;
  color: white;
  cursor: pointer;
}

/* select窗口 */
.selectL * {
  text-align: left;
}

/* 顶部左侧按钮 */
.con_topL {
  display: inline-block;
  width: 100px;
  height: 30px;
  line-height: 28px;
  margin-top: 9px;
  text-align: center;
  font-size: 16px;
  border: 1px solid #ccc;
  margin-right: 15px;
  color: black;
  background: white;
}
.con_topL_active {
  background: #1abc9c;
  color: white;
}

.up_btn {
  margin-top: 1.5px;
  width: 80px;
  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2db7f5;
  border-radius: 3px;
}

/* 分页 */
.ivu-layout-footer {
  /* border: 1px solid #e4e4e4; */
  border-top: none;
  margin-bottom: 20px;
  background: transparent !important;
}

/* 边框 */
.listBorder {
  width: 100%;
  height: auto;
  border: 1px solid #e4e4e4;
}
/* 弹窗修改 */

.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.vertical-center-modal .ivu-modal {
  top: 0;
}

.ivu-modal-header,
.ivu-modal-footer {
  background: #f7f9ff;
}
.ivu-modal-content {
  overflow: hidden;
}

/* 宽度变化时 */
@media screen and (min-width: 1302px) {
  .container {
    width: 97.5%;
  }
}
@media screen and (max-width: 1301px) {
  .container {
    width: 1000px;
    margin-left: 10px;
  }
}

.ivu-menu-item {
  font-size: 12px !important;
}

/* 输入最大最小值的数字输入框 */
.iptNum .ivu-input {
  border: none !important;
  height: 34px;
}
/* 去除input选中后的蓝框 */
.outline {
  outline: none;
}

/* table 标题 */
.ivu-table-border th {
  background: #f7f9ff !important;
}

.my_titleL {
  font-size: 18px;
  color: #222;
  font-weight: 400;
}

/* 手写table */

.table_content {
  margin-top: 20px;
  background: #e4e4e4;
  font-size: 14px;
}
.table_content td {
  background: white;
}
.table_content .tableL {
  width: 250px;
  height: 250px;
  /* background: white; */
}
/* 手写table左侧 */
.table_content p {
  padding: 5px 0;
}

.table_content .p1 img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-top: 15px;
}
.table_content .p3 span {
  padding: 4px 15px;
  background: #f04844;
  color: white;
  border-radius: 15px;
}
.table_content .p4 {
  color: #1abc9c;
}
.table_content .title {
  width: 16%;
  height: 48px;
  background: #f7f9ff;
  padding: 0 5px;
  text-align: right;
  padding: 10px;
}
.table_content .t_con {
  width: 34%;
  padding: 10px;
}
</style>


